import UrlEnum from "../constants/UrlEnum";
import { getDomain } from "../services/utils";
import { initTheme, cssVar, THEMED_TOKENS } from "./theme";
var domain = getDomain(window.location.hostname)

var Colors = {
  background: "#fafafa",
  primary: "#3996f3",
  blueDark: "#163B78",
  lightPrimary: "#3996f380",
  extraLightPrimary: "#e9f4fd",
  secondary: "#1565C0",
  backgroundPrimary: "#1e88e5",
  backgroundSecondary: "#42a5f5",
  green: "#3bbfa4",
  red: "#f44336",
  blue: "#295fd2",
  gray: "#f1f2f2",
  grayMedium: "#b1b1b1",
  black: "#000",
  snow: "#FFF",
  snowSecondary: "#FFF",
  coal: "#424242",
  transparent: "#00000000",
  atention: "#fa8c16",
}

if (domain === 'grupoVia') {
  Colors = {
    background: "#fafafa",
    primary: "#f4793b",
    blueDark: "#ff7a32",
    lightPrimary: "#ffb992",
    extraLightPrimary: "#ffb99230",
    secondary: "#b93f02",
    backgroundPrimary: "#f8884c",
    backgroundSecondary: "#fdba95",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#f4793b",
    lightPrimaryPins: "#ffb992",
  }
}

if (domain === 'smartFit') {
  Colors = {
    background: "#fff",
    primary: "#ffb612",
    blueDark: "#ff7a32",
    lightPrimary: "#0000004d",
    extraLightPrimary: "#000000a8",
    secondary: "#0000",
    backgroundPrimary: "#ffb8127a;",
    backgroundSecondary: "#00000099",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#ffb612",
    lightPrimaryPins: "#ffb612ed",
  }
}

if (domain === 'duoPrint') {
  Colors = {
    background: "#fff",
    primary: "#c11911",
    blueDark: "#ff7a32",
    lightPrimary: "#0000004d",
    extraLightPrimary: "#16171645",
    secondary: "#0000",
    backgroundPrimary: "#f8884c",
    backgroundSecondary: "#fdba95",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#c11911",
    lightPrimaryPins: "#c11a11a5",
  }
}

if (domain === 'mediaShake') {
  Colors = {
    background: "#fafafa",
    primary: "#ff7200",
    blueDark: "#460160",
    lightPrimary: "#ffb992",
    extraLightPrimary: "#ffb99230",
    secondary: "#ff031c",
    backgroundPrimary: "#f8884c",
    backgroundSecondary: "#fdba95",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#ff7200",
    lightPrimaryPins: "#ff7200b9",
  }
}

if (domain === 'territorioDigital') {
  Colors = {
    background: "#fafafa",
    primary: "#F4A703",
    blueDark: "#163B78",
    lightPrimary: "#F4A70380",
    extraLightPrimary: "#f4a8032a",
    secondary: "#3D6D8C",
    backgroundPrimary: "#F4A703",
    backgroundSecondary: "#f4a8031b",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#3D6D8C",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#F4A703",
    lightPrimaryPins: "#f4a703cd",
  }
}

if (domain === 'movImagen') {
  Colors = {
    background: "#fafafa",
    primary: "#FF6900",
    blueDark: "#163B78",
    lightPrimary: "#FF690080",
    extraLightPrimary: "#FF69002a",
    secondary: "#707070",
    backgroundPrimary: "#FF6900",
    backgroundSecondary: "#FF69001b",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#FF6900",
    lightPrimaryPins: "#ff6900d3",
  }
}

if (domain === 'yoda') {
  Colors = {
    background: "#fafafa",
    primary: "#ffcc00",
    blueDark: "#000",
    lightPrimary: "#ffcc00cc",
    extraLightPrimary: "#fff4cc",
    secondary: "#6d6e6f",
    backgroundPrimary: "#1e88e5",
    backgroundSecondary: "#42a5f5",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000000",
    snow: "#ffffff",
    snowSecondary: "#ffffff",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#cca300",
    lightPrimaryPins: "#ffcc00",
  }
}

if (domain === 'hakMedia') {
  Colors = {
    background: "#fafafa",
    primary: "#580ECC",
    blueDark: "#2F0A66",
    lightPrimary: "#580ECC80",
    extraLightPrimary: "#E6DAFF",
    secondary: "#3D0D8C",
    backgroundPrimary: "#4A0CB0",
    backgroundSecondary: "#580ECC",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#4727A3",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
    primaryPins: "#580ECC",
    lightPrimaryPins: "#570eccaf",
  };
}

if (domain === 'blaster') {
  Colors = {
    background: "#ffffff",
    primary: "#042940",
    blueDark: "#163B78",
    lightPrimary: "#04294080",
    extraLightPrimary: "#e9f4fd",
    secondary: "#042940",
    backgroundPrimary: "#1e88e5",
    backgroundSecondary: "#42a5f5",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
  }
}

if (domain === 'laMediatica') {
  Colors = {
    background: "#ffffff",
    primary: "#100c91",
    blueDark: "#0b86a2",
    lightPrimary: "#100c9180",
    extraLightPrimary: "#b5b3e1",
    secondary: "#0b86a2",
    backgroundPrimary: "#1e88e5",
    backgroundSecondary: "#42a5f5",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#295fd2",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#fa8c16",
  }
}

if (domain === 'dv360') {
  Colors = {
    background: "#ffffff",
    primary: "#34A853",
    blueDark: "#0d652d",
    lightPrimary: "#34A85380",
    extraLightPrimary: "#34A8532a",
    secondary: "#1a73e8",
    backgroundPrimary: "#34A853",
    backgroundSecondary: "#81c995",
    green: "#3bbfa4",
    red: "#f44336",
    blue: "#1a73e8",
    gray: "#f1f2f2",
    grayMedium: "#b1b1b1",
    black: "#000",
    snow: "#FFF",
    snowSecondary: "#FFF",
    coal: "#424242",
    transparent: "#00000000",
    atention: "#FBBC05",
    primaryPins: "#34A853",
    lightPrimaryPins: "#34A853b9",
  }
}

/*
  ---- Tema claro / oscuro ----
  Tokens neutros adicionales (valores light exactos de los hex que se usaban
  hardcodeados en la app, así el modo claro no cambia) y tokens constantes que
  NO deben cambiar con el tema:
  - white / pureBlack: texto o bordes sobre fondos de color (botones primarios,
    marcos de pantalla, etc.). Usar `Colors.white` para "letra blanca sobre
    primary" y `Colors.snow` para "superficie blanca".
  - onPrimarySoft: texto suave sobre primary (antes se usaba extraLightPrimary).
*/
Colors = {
  ...Colors,
  border: "#e8e8e8",
  borderStrong: "#d9d9d9",
  surfaceMuted: "#f5f5f5",
  textStrong: "#262626",
  textSecondary: "#595959",
  textMuted: "#8c8c8c",
  overlay: "rgba(0, 0, 0, 0.45)",
  tintWarning: "#fffbe6",
  tintSuccess: "#ebf8f2",
  tintInfo: "#ebf5fe",
  tintError: "#fdeaee",
  white: "#FFF",
  pureBlack: "#000",
  onPrimarySoft: Colors.extraLightPrimary,
  // Derivados del primary de la marca; los valores reales los calcula theme.js
  // (ver deriveBrandTokens). Acá quedan los de fallback.
  primaryAccent: Colors.primary,
  onPrimary: "#FFF",
};

// Valores light concretos (los de siempre) -> se inyectan como variables CSS
// y los tokens pasan a referenciarlas, así el tema cambia sin recargar.
const lightNeutrals = THEMED_TOKENS.reduce((acc, token) => {
  acc[token] = Colors[token];
  return acc;
}, {});
initTheme(lightNeutrals, Colors.primary);
THEMED_TOKENS.forEach(token => {
  Colors[token] = cssVar(token);
});

export default Colors;
